import { LocalizationKeyTreeType } from "../keys";

export const de_DE: LocalizationKeyTreeType = {
	application: {
		header: {
			banner: {
				stage:
					"Sie befinden sich auf einer Abnahmeumgebung." +
					" Bitte beachten Sie, dass diese Umgebung nicht für den produktiven Einsatz gedacht ist.",
				preview:
					"Sie befinden sich auf der Vorschau-Umgebung. Hier können Sie die Entwicklung von Fachverfahren testen."
			},
			info: {
				title: "Anwendungsinformation öffnen",
				version: { label: "Version" },
				accessibility: { label: "Erklärung zur Barrierefreiheit" },
				documents: {
					label: "Unterlagen",
					accessibilityLabel: "Unterlagen öffnen (öffnet in neuem Tab)"
				}
			},
			title: {
				backToDashboard: "Zurück zum Dashboard",
				reload: "Seite neu laden"
			}
		},
		view: {
			accessibility: {
				title: "Erklärung zur Barrierefreiheit",
				buttons: { close: { title: "Modal schließen" } }
			},
			roles: {
				title: "Zugewiesene Rollen",
				column: {
					type: { title: "Type" },
					name: { label: "Name" },
					baseRole: { label: "Rolle" },
					client: { label: "Zugehörigkeit" }
				},
				role: {
					unknown: "Unbekannt",
					leiter: "Leiter:in",
					sachbearbeiter: "Sachbearbeiter:in (Standard)",
					sachbearbeiter_erweitert: "Sachbearbeiter:in (Erweitert)",
					betrachter: "Betrachter:in"
				},
				buttons: { close: { title: "Modal schließen" } }
			}
		},
		content: {
			logout: {
				label: "Sie wurden erfolgreich abgemeldet.",
				button: {
					label: "Anmelden"
				}
			},
			noPublications: {
				label: "Ihre Anmeldung war erfolgreich.",
				content:
					"Es wurden noch keine Fachverfahren bereitgestellt, die Sie verwenden können. Erstellt und bereitgestellt werden Fachverfahren im MODUL-F Fachverfahrens-Editor."
			},
			noAccess: {
				label: "Ihre Anmeldung war erfolgreich.",
				content:
					"Derzeit verfügen Sie nicht über die erforderliche Berechtigung, um ein Fachverfahren zu nutzen. Um Zugriff zu erhalten, bitten wir Sie, sich an Ihre Administration zu wenden und eine entsprechende Berechtigung anzufordern."
			}
		},
		brand: "MODUL-F",
		titleParts: {
			prefix: "Fachverfahrens",
			main: "portal"
		}
	},
	resources: {
		"attachment-handler": {
			error: {
				unknown: "Die Datei $filename$ konnten nicht hochgeladen werden.",
				unacceptableExtension:
					"Die Datei $filename$ konnte nicht hochgeladen werden. Dateien vom Typ $extension$ können nicht hochgeladen werden.",
				internal: "Ein interner Fehler ist aufgetreten.",
				abort: "Beim Abbrechen trat ein Fehler auf.",
				"not-found": "Die ausgewählte Datei kann nicht mehr gefunden werden.",
				security: "Kein Zugriff auf die ausgewählte Datei.",
				"no-preview": "Eine Vorschau existiert nicht.",
				"invalid-file": "Die letzte angegebene Datei konnte nicht verarbeitet werden.",
				"no-handler": "Der Anhang kann nicht verarbeitet werden."
			}
		}
	},
	veto: {
		title: "Vorgang abbrechen",
		message:
			"Sind Sie sicher, dass Sie den Vorgang abbrechen möchten? Bitte beachten Sie, dass getätigte Eingaben verworfen werden.",
		buttonDiscard: "Ja, Vorgang abbrechen",
		buttonAbort: "Nein, zurück zum Formular"
	},
	error: {
		INTERNAL_CLIENT_ERROR: "Interner Client Fehler",
		VALIDATION_ERROR: "Validierungsfehler",
		PAGE_NOT_FOUND_ERROR: "Seite nicht gefunden",
		SAVING_FAILED_ERROR: "Speichern fehlgeschlagen",
		HTTP_ERROR: "HTTP Fehler",
		UNKNOWN_ERROR: "Interner Fehler",
		FILE_INVALID_MESSAGE_ERROR: "Die gewählte Datei kann nicht eingelesen werden.",
		UNKNOWN_MESSAGE_ERROR: "Ein unbekannter Fehler ist aufgetreten.",
		GENERATE_DOCUMENT_ERROR: "Die Generierung des Dokuments ist fehlgeschlagen.",
		GENERATE_DOCUMENT_WITH_CAUSE_ERROR: "Die Generierung des Dokuments ist fehlgeschlagen. Grund: $cause$",
		SIGN_DOCUMENT_WITH_CAUSE_ERROR: "Der Signiervorgang des Dokuments ist fehlgeschlagen. Grund: $cause$",
		SIGN_USER_NOT_READY_ERROR: "Signierung nicht möglich: $cause$",
		SIGN_STATUS_PENDING:
			"Der Signiervorgang ist noch nicht abgeschlossen. Bitte schließen Sie die Signierung bei sign-me ab und versuchen Sie es erneut.",
		SIGN_TRANSACTION_EXPIRED:
			"Das Zeitfenster zum Abrufen des signierten Dokuments bei sign-me ist abgelaufen. " +
			'Bitte starten Sie den Signiervorgang über "Dokument signieren" erneut.',
		DOWNLOAD_SIGNED_DOCUMENT_ERROR:
			"Das signierte Dokument konnte nicht abgerufen werden. Beachten Sie, dass Dokumente nur innerhalb von 5 Minuten nach der Signierung in sign-me heruntergeladen werden können. Starten Sie den Signatur-Vorgang ggf. erneut.",
		SEND_EMAIL_ERROR: "Der E-Mail-Versand ist fehlgeschlagen.",
		UNEXPECTED_ERROR: "Ein unerwarteter Fehler ist aufgetreten."
	},
	externalEnumeration: {
		EmailBetreff: {
			"0": {
				label: "Warten auf BiFi-Abrechnung"
			},
			"1": {
				label: "Informationen angefordert"
			}
		}
	},
	features: {
		buchungsassistent: {
			error: {
				internalServerError: "Der Vorgang konnte nicht vom Buchungsassistenten verarbeitet werden. $reason$",
				missingValue: "Es wurden nicht alle benötigten Felder zum Anlegen des Vorgangs ausgefüllt.",
				invalidFile: "Das Nachweisdokument darf nur im Format PDF oder TIF sein."
			}
		},
		xFinanzDatei: {
			error: {
				missingValue: "Es wurden nicht alle benötigten Felder für die xFinanz-Datei ausgefüllt.",
				internalServerError: "Die xFinanz-Datei konnte nicht erstellt werden. $reason$",
				deleteError: "Die xFinanz-Datei konnte nicht gelöscht werden."
			}
		},
		externalEnumeration: {
			contactList: {
				warning:
					"Die Liste der Kontakte konnte nicht vollständig geladen werden. Bitte prüfen Sie, ob die Kontaktlisten mit den Schlüsseln $appID$ veröffentlicht sind und ob Sie über die erforderlichen Berechtigungen zum Zugriff auf die Kontaktlisten verfügen. Sie können weiterhin manuell Kontakte erfassen."
			}
		},
		wiedervorlagen: {
			dueCount: {
				single: "$count$ bald fällige oder überfällige Wiedervorlage",
				multiple: "$count$ bald fällige oder überfällige Wiedervorlagen"
			}
		},
		stammdaten: {
			notification: {
				extract: {
					success: {
						title: "Aktion erfolgreich",
						message:
							"Daten aus diesem Vorgang wurden erfolgreich in die Stammdatenliste $listname$ übertragen.",
						button: {
							label: "$listname$ öffnen"
						}
					},
					error: {
						title: "Aktion nicht erfolgreich",
						message:
							"Die Übertragung von Daten aus diesem Vorgang in die Stammdatenliste $listname$ war nicht erfolgreich. Bitte versuchen Sie es erneut.",
						button: {
							label: "Stammdaten übertragen"
						}
					},
					warning: {
						title: "Stammdaten nicht verfügbar",
						message:
							"Die referenzierte Stammdatenliste ist in dieser Umgebung nicht verfügbar. Die Stammdaten konnten nicht übertragen werden."
					}
				}
			},
			footer: {
				overview: "Seitennavigation"
			}
		},
		button: {
			disabledReason: "Diese Aktion ist aktuell nicht verfügbar, da die Voraussetzungen noch nicht erfüllt sind."
		},
		control: {
			strikethroughHint: "Wert wurde durch den korrigierten Wert überschrieben."
		},
		zahlungsvorgangEpaybl: {
			error: {
				missingValue:
					"Es wurden nicht alle für die Zahlungsanbahnung benötigten Informationen ermittelt. Bitte prüfen Sie die Konfiguration.",
				requestFailed: "Die Anfrage an die Zahlungsanbindung konnte nicht verarbeitet werden. $reason$",
				saveFailed:
					"Der aktuelle Bearbeitungsstand konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.",
				unbekannt: "Unbekannter Fehler."
			},
			disabledReason: {
				create: "Der Zahlungsvorgang kann erst angelegt werden, wenn ein Betrag vorhanden ist und noch kein Zahlungsvorgang angelegt wurde.",
				status: "Der Zahlungsstatus kann erst abgeholt werden, wenn ein Zahlungsvorgang angelegt wurde."
			},
			hint: {
				wirdAngelegtFuer: "Der Zahlungsvorgang wird für einen Betrag von $betrag$ angelegt.",
				wurdeAngelegtFuer: "Der Zahlungsvorgang wurde für einen Betrag von $betrag$ angelegt."
			},
			success: {
				statusUpdated: "Der Zahlungsvorgang wurde als bezahlt festgestellt."
			}
		},
		notification: {
			title: {
				success: "Erfolg",
				info: "Info",
				warning: "Warnung",
				error: "Fehler"
			},
			info: {
				exportCsv:
					"Der Export der $appType$ $appKey$ wurde am $timestamp$ gestartet. " +
					"Wenn Sie das Fenster schließen oder neu laden, wird der Vorgang abgebrochen."
			},
			success: {
				exportCsv:
					"Der Export der $appType$ $appKey$ vom $timestamp$ war erfolgreich. " +
					"Sie können den Export in Ihrem lokalen Downloadordner abrufen.",
				newAntrag: "Ein neuer Vorgang wurde hinzugefügt.",
				eldorado: {
					generating: "Das Veraktungsarchiv wurde erfolgreich erzeugt.",
					transmitting: "Das Archiv wurde erfolgreich an ELDORADO übertragen."
				},
				processLinking: {
					createdLinkedProcess: "Ein neuer Vorgang wurde im verknüpften Fachverfahren angelegt."
				}
			},
			error: {
				textbausteine: {
					openModal: "Die Textbausteine konnten nicht geöffnet werden.",
					export:
						"Der Export der Textbausteine für $appKey$ vom $timestamp$ war nicht erfolgreich. " +
						"Bitte versuchen Sie es erneut oder wenden Sie sich an Ihren Administrator.",
					import:
						"Der Import der Textbausteine für $appKey$ vom $timestamp$ war nicht erfolgreich. " +
						"Bitte versuchen Sie es erneut oder wenden Sie sich an Ihren Administrator.",
					invalidImportFile:
						"Der Import der Textbausteine für $appKey$ vom $timestamp$ war nicht erfolgreich. " +
						"Bitte prüfen Sie die Import-Datei."
				},
				assignWiedervorlage: "Der Wiedervorlage konnte nicht zugewiesen werden.",
				assignStammdaten: "Dem Stammdatendokument konnte keine Person zugewiesen werden.",
				wiedervorlagenErledigt:
					"Der Status 'Erledigt' konnte nicht gesetzt werden. Es liegt ein technisches Problem vor.",
				unexpectedError:
					"Ein unerwarteter Fehler ist aufgetreten. Bitte wenden Sie sich an einen Administrator.",
				environmentData: "Es ist ein Fehler beim Laden der Umgebungsdaten aufgetreten.",
				archive: "Es ist ein Fehler beim Verakten aufgetreten.",
				exportCsv: {
					serverError:
						"Der Export der $appType$ $appKey$ vom $timestamp$ war nicht erfolgreich. " +
						"Bitte versuchen Sie es erneut.",
					queueFull:
						"Der Export der $appType$ konnte nicht gestartet werden, " +
						"da die maximale Anzahl paralleler Export-Prozesse erreicht wurde. " +
						"Führen Sie die Aktion erneut aus, sobald ein laufender Export abgeschlossen ist"
				},
				email: {
					missingAttachment: "Bitte wählen Sie ein Dokument zum Versenden aus.",
					missingEmpfaenger: "Bitte geben Sie eine:n Empfänger:in an.",
					missingBetreff: "Bitte geben Sie einen Betreff an.",
					missingMessage: "Bitte geben Sie eine Nachricht ein.",
					malformedEmailAddress: "Die eingegebene E-Mail-Adresse ist nicht gültig.",
					technicalError:
						"Der E-Mail-Versand ist aufgrund eines technischen Fehlers fehlgeschlagen. " +
						"Bitte kontaktieren Sie Ihren Administrator.",
					validationFailed:
						"Die E-Mail konnte nicht versendet werden, da die Daten ungültig sind. " +
						"Bitte korrigieren Sie die Eingaben und versuchen Sie es erneut."
				},
				gatewayEntscheidung: "Es ist ein Fehler bei der Navigationentscheidung aufgetreten.",
				duplicateProcess: "Der Prozess konnte nicht dupliziert werden.",
				eldorado: {
					generatingError: "Es ist ein Fehler beim Generieren des Veraktungsarchivs aufgetreten.",
					generatingErrorWithCause:
						"Es ist ein Fehler beim Generieren des Veraktungsarchivs aufgetreten. " + "Fehler: $cause$",
					transmittingError:
						"Es ist ein Fehler beim Übertragen des Veraktungsarchivs an ELDORADO aufgetreten. " +
						"Bitte generieren Sie den Veraktungsinhalt erneut.",
					transmittingErrorWithCause:
						"Es ist ein Fehler beim Übertragen des Veraktungsarchivs an ELDORADO aufgetreten. " +
						"Bitte generieren Sie den Veraktungsinhalt erneut. " +
						"Fehler: $cause$",
					metadataErrorWithCause:
						"Es ist ein Fehler beim Laden der Metadaten für die Veraktung aufgetreten\n. " +
						"Fehler: $cause$",
					authenticationError: "Fehlende Berechtigung zum Starten des Veraktungsvorgangs.",
					lockedError: "Es gibt bereits einen aktiven Veraktungsvorgang für diesen Vorgang.",
					conflictError:
						"Die Vorgangsdaten wurden bearbeitet. Sie müssen den Vorgang neuladen, " +
						"bevor Sie die Veraktung starten können.",
					cancellationError:
						"Die Veraktung konnte nicht abgebrochen werden. " +
						"Möglicherweise verfügen Sie nicht über die nötige Berechtigung.",
					missingFeldError: "Diese Angabe ist zur Ablage im ELDORADO-System erforderlich."
				},
				xakte: {
					generatingError: "Es ist ein Fehler beim Erstellen des xAkte-Veraktungspakets aufgetreten.",
					generatingErrorWithCause:
						"Es ist ein Fehler beim Erstellen des xAkte-Veraktungspakets aufgetreten. Fehler: $cause$",
					transmittingError:
						"Es ist ein Fehler beim Übertragen des Veraktungspakets an xAkte aufgetreten. " +
						"Bitte generieren Sie den Veraktungsinhalt erneut.",
					transmittingErrorWithCause:
						"Es ist ein Fehler beim Übertragen des Veraktungspakets an xAkte aufgetreten. " +
						"Bitte generieren Sie den Veraktungsinhalt erneut. Fehler: $cause$",
					metadataError: "Es ist ein Fehler beim Laden der xAkte-Metadaten aufgetreten.",
					metadataErrorWithCause:
						"Es ist ein Fehler beim Laden der xAkte-Metadaten aufgetreten. Fehler: $cause$"
				},
				assigneeCandidates: {
					genericError: "Die Liste der zuweisbaren Nutzer:innen konnte nicht geladen werden."
				},
				process: {
					unauthorized:
						"Der Vorgang konnte nicht geöffnet werden. Möglicherweise sind Sie für diesen Vorgang nicht berechtigt."
				},
				processLinking: {
					creatingLinkedProcessFailed:
						"Der verknüpfte Vorgang konnte nicht angelegt werden. Bitte wenden Sie sich an einen Administrator."
				}
			},
			warning: {
				eldorado: {
					excludedAttachments:
						"Im Antrag befinden sich Dateien mit Dateitypen, die für die Veraktung nicht zugelassen sind. " +
						"Diese Dateien werden nicht veraktet: $excludedFiles$",
					excludedMsgAttachments:
						"Folgende E-Mail-Dateien (.msg) wurden nicht veraktet, da sie Anhänge in nicht zugelassenem " +
						"Format enthalten: $excludedFiles$",
					docConversion:
						"Folgende Dateien konnten nicht konvertiert und daher nicht in das Veraktungsarchiv " +
						"aufgenommen werden: $conversionWarnings$",
					duplicatedItemTexts:
						"Die Anzeigetexte für das Metadata: ABSENDER, sind nicht eindeutig. Duplikate werden entfernt: " +
						"$duplicatedText$"
				},
				duplicateProcess: {
					removedFields:
						"Der Vorgang wurde in die neueste Version kopiert, jedoch können folgende Felder nicht übernommen werden, da sie entfernt oder angepasst wurden:"
				}
			},
			content: "$message$"
		},
		popUpMenu: {
			expandAll: {
				openTitle: "Weitere Tabellenfunktionen öffnen",
				closeTitle: "Weitere Tabellenfunktionen schließen"
			}
		},
		modals: {
			title: {
				loeschenModal: "Wirklich löschen?",
				emailConfirmModal: "Dokument versenden"
			},
			content: {
				loeschenModal: "Wollen Sie den Eintrag wirklich löschen?",
				emailConfirmModal:
					"Für den Versand wurde kein Dokument ausgewählt. Wenn Sie ohne Auswahl fortfahren, " +
					"wird die E-Mail ohne ein Dokument im Anhang versendet.",
				emailConfirmModalSicher: "Sind Sie sicher, dass Sie fortfahren wollen?"
			},
			button: {
				abbrechen: "Abbrechen",
				abbrechenUndZurueck: `Abbrechen und zurück`,
				loeschen: "Löschen",
				bestaetigen: "Ja, fortfahren",
				close: "Schließen"
			},
			eldorado: {
				veraktenTitle: "Veraktungsinhalt",
				veraktenButton: "Verakten",
				generalDescription:
					"Die ausgewählten Dokumente des Veraktungsinhalts werden an ELDORADO zur Veraktung übermittelt. Standardmäßig\n" +
					"umfasst die Veraktung zwei Dokumente mit folgendem Inhalt:",
				antragsdatenDescription:
					"Antragsdaten: aktueller Antrag, initialer Antrag, initial angehängte Dokumente sowie eine Änderungshistorie",
				prozessdatenDescription: "Prozessdaten: aktuelle Prozessdaten und eine Änderungshistorie",
				additionalDescription:
					"Optional können zusätzlich hochgeladene und generierte Dokumente für die Veraktung ausgewählt werden.",
				documentSelectionTitle: "Dokumente",
				documentSelectionDefaultText: "Es stehen keine weiteren Anhänge zur Auswahl zur Verfügung",
				aktenkennzeichenTitle: "Aktenkennzeichen *",
				mappenNummerTitle: "Mappennummer",
				betreffTitle: "Betreff",
				absenderTitle: "Absender",
				bezugTitle: "Bezug",
				dokumentenArtTitle: "Dokumenten-Art",
				papierformTitle: "Papierform",
				generateButton: "Veraktungsinhalt generieren",
				generateAgainButton: "Veraktungsinhalt erneut generieren",
				previewTitle: "Vorschau",
				previewDownloadLinkTitle: "Veraktungsinhalt herunterladen (Vorschau)",
				forceCancelModalTitle: "Veraktungsvorgang wirklich abbrechen?",
				forceCancelModalText: "Wollen Sie das Abbrechen des Veraktungsvorgangs wirklich erzwingen?"
			}
		},
		deleteProcess: {
			title: "Löschen des Vorgangs",
			content: {
				createdAutomatically:
					"Automatisch eingegangene Daten aus einem Onlinedienst können nicht wiederhergestellt werden und die Löschung kann nicht rückgängig gemacht werden. Was möchten Sie tun?",
				createdManually: "Die Löschung kann nicht rückgängig gemacht werden. Was wollen Sie tun?"
			},
			button: "Löschen",
			cancel: "Abbrechen",
			error: "Der Vorgang konnte aufgrund eines Fehlers nicht gelöscht werden."
		},
		zugehoerigkeit: {
			title: "Zugehörigkeit ändern",
			info:
				"Durch das Ändern der Zugehörigkeit werden der Vorgang und ggf. verknüpfte Wiedervorlagen " +
				"der entsprechenden Zugehörigkeit zugeordnet. Danach sind sie nur für Anwender:innen mit der entsprechenden " +
				"Zugehörigkeit sichtbar und zur Bearbeitung freigeschaltet.",
			button: "Speichern",
			cancel: "Abbrechen",
			error: "Die Zugehörigkeit konnte nicht geändert werden. Bitte kontaktieren Sie Ihren Administrator."
		},
		postfach: {
			error: {
				missingInboxReference:
					"Es kann keine Nachricht an das Postfach übermittelt werden, " +
					"da keine Postfach-ID übermittelt wurde.",
				missingInboxReferenceLabel: "Hinweis zum fehlenden Bund-ID-Postfach",
				toManyFiles: "Es können maximal $maxFiles$ Dateien versendet werden."
			},
			helper: {
				attachments: "Es können maximal $maxFiles$ Dateien versendet werden."
			},
			info: {
				attachments:
					"Es können ausschließlich Dateien in den Formaten $allowedExtensions$ mit einer maximalen Größe von jeweils $allowedSizeMb$ MB berücksichtigt werden.\n" +
					"Die Auswahl wurde bereits entsprechend vorgefiltert und enthält lediglich Dateien, die diesen Vorgaben entsprechen. " +
					"Sollten Sie bestimmte Dateien vermissen, prüfen Sie bitte die Dateiformate sowie die jeweilige Dateigröße der hochgeladenen Dateien."
			}
		}
	},
	component: {
		toast: {
			header: {
				error: "Fehler",
				success: "Erfolg",
				info: "Info",
				warning: "Warnung"
			}
		},
		autocomplete: {
			hintTemplate: "$count$ von $total$ Optionen"
		},
		input: {
			clientSelection: {
				label: "Zugehörigkeit"
			}
		},
		button: {
			apply: { label: "Übernehmen" },
			save: { label: "Speichern" },
			close: { label: "Schließen" },
			cancel: { label: "Abbrechen" }
		},
		modal: {
			general: {
				button: { close: { title: "Modal schließen" } }
			},
			logout: {
				title: "Abmelden",
				message:
					"Sie werden in allen offenen Tabs abgemeldet und nicht gespeicherte Änderungen gehen verloren.",
				caution: "Es gibt nicht gespeicherte Änderungen in diesem Tab.",
				button: {
					cancel: { label: "Abbrechen" },
					logout: { label: "Abmelden" }
				}
			},
			client: {
				title: {
					new: "Zugehörigkeit festlegen"
				},
				button: {
					confirm: {
						new: { label: "Weiter" }
					}
				}
			}
		}
	},
	wf: {
		general: {
			actions: {
				cancel: "Abbrechen",
				start: "Starten"
			}
		},
		sidemenu: {
			startProcess: {
				label: "Prozess starten"
			},
			mytasks: {
				label: "Meine Aufgaben"
			},
			availabletasks: {
				label: "Verfügbare Aufgaben"
			},
			alltasks: {
				label: "Alle Aufgaben"
			},
			completedprocesses: {
				label: "Abgeschlossene Prozesse"
			}
		},
		startprocess: {
			title: "Prozess auswählen",
			dropdown: {
				title: "Verfügbare Prozesse"
			},
			selecteddocuments: {
				id: "Dokument ID",
				type: "Dokumententyp",
				name: "Dokumentenname",
				unselect: "Entfernen"
			}
		},
		notification: {
			success: {
				startprocess: "Instanz von $processDefinitionName$ erfolgreich gestartet."
			},
			error: {
				startprocess: "Konnte keine Instanz von $processDefinitionName$ starten.",
				outdatedProcessVersion: {
					message:
						"Der Prozess kann nicht gestartet werden, da die verwendete Fachverfahrensversion nicht aktuell ist. Bitte laden Sie die Seite neu.",
					title: "Fehler beim Erstellen des Vorgangs"
				},
				stammdatenVersion: {
					title: "Fehler beim Erstellen des Stammdateneintrags",
					message:
						"Der Stammdateneintrag konnte nicht erstellt werden, da die verwendete Version nicht aktuell ist. Bitte laden Sie die Seite neu."
				},
				updatetask: "Task konnte nicht gespeichert werden.",
				completetask:
					"Der Task konnte nicht eindeutig beendet werden. Bitte laden Sie den Vorgang neu und prüfen Sie den aktuellen Stand.",
				completetaskFailed: "Der Task konnte nicht beendet werden.",
				gatewayTimeout:
					"Der Server hat nicht rechtzeitig geantwortet. Ihre Eingaben wurden nicht verworfen. Bitte versuchen Sie es erneut.",
				gatewayTimeoutRetry: "Erneut versuchen",
				taskPermission:
					"Die Berechtigung für den Task konnte nicht geprüft werden. Bitte versuchen Sie es erneut.",
				assigntask: "Der Vorgang konnte nicht zugewiesen werden.",
				assigntask_archival:
					"Der Vorgang kann nicht zugewiesen werden, da er momentan veraktet wird. " +
					"Bitte schließen Sie die Veraktung zunächst ab oder brechen Sie diese ab.",
				assigntask_archival_title: "Vorgang wird veraktet",
				showdiagram: "Prozessdiagramm für $processDefinitionName$ kann nicht angezeigt werden.",
				validationFailedTitle: "Validierung fehlgeschlagen",
				validationFailedMessage: "Die eingegebenen Daten sind nicht gültig.",
				savingFailedTitle: "Fehler beim Speichern des Vorgangs",
				lockProcessErrorTitle: "Der Vorgang ist gesperrt",
				savingFailedMessage: "Das Speichern ist fehlgeschlagen",
				lockProcessErrorMessage: "Der Vorgang wird derzeit bearbeitet. Sie können keine Änderungen vornehmen.",
				conflictedSavingMessage:
					"$user$ hat den Vorgang $vorgangsnummer$ am $dateTime$ geändert. " +
					"Die Änderung kann nicht gespeichert werden.",
				createDocumentTitle: "Dokument kann nicht erstellt werden",
				createDocumentMessage:
					"Das Dokument kann nicht erstellt werden. Versuchen Sie es nach einem Neuladen der Anwendung ggf. erneut."
			}
		}
	},
	general: {
		indication: {
			info: "Information",
			success: "Erfolgreich",
			important: "Wichtig",
			caution: "Achtung",
			warning: "Warnung",
			error: "Fehler"
		}
	}
};
